import React from 'react';
import moment from 'moment';
import { get, getOr, map, startCase } from 'lodash/fp';
import { Icon } from 'rsuite';
import toFileExtName from '../toFileExtName';
import { parseInt, toBase64Encode } from '../utils';
import Relationship from '../../components/guest/Relationship';
import SignatureBox from '../../components/SignatureBox';

export default (value, colSettings) => {
  const { name, fieldType, options = [] } = colSettings;
  switch (fieldType) {
    case 'file':
      if (!value) return '';
      return (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`/cf-file/?file=${toBase64Encode(encodeURIComponent(value))}`}
        >
          {`Open "${toFileExtName(value)}" File `}
          <Icon icon="external-link" />
        </a>
      );
    case 'guest_relation':
      if (!value || value === '0') return '';
      return (
        <Relationship
          guestId={parseInt(value)}
          style={{ marginRight: 30 }}
          showHeading
        />
      );
    case 'radio':
    case 'select':
      return getOr('', value, options);
    case 'option_yesno':
      return getOr('No', value, options);
    case 'checkbox':
      return map(
        val => <div key={`item-${val}`}>{get(val, options)}</div>,
        value
      );
    case 'date':
    case 'datetime':
      if (!value || !moment(value).isValid()) return '';
      return moment(value).format('ll');
    case 'signature':
      if (!value || value === '0') return '';
      return <SignatureBox signatureId={parseInt(value)} field={name} />;
    default:
      if (name === 'name') return startCase(value);
      return value;
  }
};
